import React, { useEffect, useState } from "react";
import Dashboard from "../layouts/Dashboard";
import Papa from "papaparse";
import exportFromJSON from "export-from-json";
import axios from "../services/axios";
import url from "../services/url";
import swal from "sweetalert";
import Select from "react-select";
import { set } from "lodash";
//import CenteredTree from "./tree";

const ChatBotService = (props) => {
  const [step, setStep] = useState("");
  const [getdata, setGetData] = useState([]);
  const [stepParent, setStepParent] = useState("");
  const [errorStep, setErrorStep] = useState("");
  const [stepParentNodeData, setStepParentNodeData] = useState();
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    loadQuestions();
  }, [refresh]);

  const newdata = [{ value: null, label: "select" }];
  function loadQuestions() {
    // var data = "";

    // var config = {
    //   method: "get",
    //   url: "/chatBotService/AllSteps",
    //   headers: {
    //     Authorization: `Bearer ${localStorage.getItem("user.token")}`,
    //     "Content-Type": "application/json",
    //   },
    //   data: data,
    // };

    // axios(config)
    axios
      .get("chatBotService/AllSteps", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then(function (response) {
        console.log("get data", response.data);
        setGetData(response.data);
        let resData = response.data;
        console.log("step", response.data);
        resData.map((ele) => {
          let objData = {
            value: ele._id,
            label: ele.step,
          };
          newdata.push(objData);
          // console.log("step", objData);
        });
        setStepParentNodeData(newdata);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const handleStep = (e) => {
    setStep(e.target.value);
    setRefresh(false);
  };

  const handleStepParentNode = (e) => {
    setStepParent(e.value !== "select" ? e.value : null);
    console.log("step parent", e.value);
    setRefresh(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("d1", step);
    console.log("d2", stepParent === "" ? null : stepParent);
    axios
      .post(
        "chatBotService",
        {
          step: step,
          parentId: stepParent === "" ? null : stepParent,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      )
      .then((res) => {
        console.log(res.data);
        setRefresh(true);
        // window.location.reload();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div>
      <Dashboard title="Chatbot Service">
        <div className="col-lg-3  col-sm-12">
          <textarea
            onChange={handleStep}
            className="form-control"
            rows="1"
            placeholder="Enter Step..."
          ></textarea>

          <div className="App">
            <Select
              options={stepParentNodeData}
              onChange={handleStepParentNode}
            />
          </div>
          <button
            type="submit"
            onClick={handleSubmit}
            data-toggle="modal"
            data-target="#myModal"
            className="btn btn-primary"
            value="Submit Button"
          >
            submit
          </button>
        </div>
        {/* <CenteredTree /> */}  
      </Dashboard>
    </div>
  );
};

export default ChatBotService;
